import React, { useMemo, useRef } from 'react';
import useDuperbrowseScrollRestoration from '../../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import RowWrapper from './RowWrapper';
const HiddenRow = ({ items , width , height , extraItemHeight =0  })=>{
    const itemIds = useMemo(()=>items.map((item)=>item.dto.duperbrowseItemId), [
        items
    ]);
    const rowRef = useRef(null);
    useDuperbrowseScrollRestoration(itemIds, rowRef);
    return /*#__PURE__*/ React.createElement(RowWrapper, {
        style: {
            width: width,
            height: height + extraItemHeight
        },
        ref: rowRef
    });
};
HiddenRow.displayName = 'HiddenRow';
export default /*#__PURE__*/ React.memo(HiddenRow);
